import React from 'react';
import { fadeInAnimate } from "utils/animation";

const SeoAuditHeader = ({ siteKey }) => {
    return (
        <div
            className=" rounded-xl shadow-md border-l-4"
            style={{
                color: "#ccc !important",
                ...fadeInAnimate("300ms"), // Merge the animation styles
            }}
        >
            <h1
                style={{
                    color: "#333", 
                }}
            >
                SEO Audit
            </h1>

            {/* Check for keyword presence in title, meta, and H1 */}
            <div
                className="mt-2 text-sm"
                style={{
                    color: "#333",
                    lineHeight: 1.475,
                    paddingTop: 12,
                    fontWeight: 300,
                }}
            >
                We have analysed <strong>{siteKey}</strong> and assessed how
                to improve your search engine rankings.
            </div>
        </div>
    );
};

export default SeoAuditHeader;
